import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-outlined p-4" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "ログアウト")
], -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_account_info = _resolveComponent("account-info")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_account_info, {
                user: _ctx.store.state.user.user
              }, null, 8, ["user"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "text-link cursor-pointer",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLogout && _ctx.onLogout(...args)))
              }, _hoisted_5)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}